// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridEmpresas_ButtonSection__kacVn","UlCuston":"gridEmpresas_UlCuston__MDQlG"};